import { render, staticRenderFns } from "./Composed.vue?vue&type=template&id=335150f0&"
import script from "./Composed.vue?vue&type=script&lang=js&"
export * from "./Composed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports